// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__4Gw3s","col":"styles_col__15UP_"};